import React from 'react';
import Header from './components/header'
import Body from './components/body'
import Footer from './components/footer'
import {
  BrowserRouter as Router
} from "react-router-dom";
import './App.css';

function App() {
  return (
    <Router>
      <div className="wrapper">
        <Header />
        <Body />
        <Footer />
      </div>
      <div className="scroll-up">
        <a href="#totop"><i className="fa fa-angle-double-up"></i></a>
      </div>
    </Router>
  );
}

export default App;
